import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { environment } from '@app/env-service';

@Component({
  selector: 'auth-error',
  templateUrl: './auth-error.component.html',
  styleUrls: ['./auth-error.component.scss'],
})
export class AuthErrorComponent {
  public errorType :string = this.route.snapshot.params.type || null;
  public loginUrl :string = environment.url + '/auth/enterprise/login';

  constructor(private route :ActivatedRoute) {
    this.route.paramMap.subscribe((params) => {
      this.errorType = params.get('type') || null;
    });
  }
}
